import { useQuery } from '@tanstack/react-query';

import { SurveyAPI } from '../survey';
import { SURVEY_FORM_NAMESPACE } from '../../constants';
import { ApiSurveyFormResponse } from '../../types/survey';

const useRequestSurveyForm = (unique_id: string | null | undefined) => {
    const { data, isLoading, error } = useQuery<ApiSurveyFormResponse, Error>({
        queryKey: [SURVEY_FORM_NAMESPACE, unique_id],
        queryFn: () => SurveyAPI.fetchSurveyForm(unique_id as string),
        enabled: !!unique_id,
    });

    return { data: data ?? null, loading: isLoading, error };
};

export default useRequestSurveyForm;
